export const PUBLISHING_JOURNEY = {
  FLEXI: {
    key: 'FLEXI',
  },
  PUBC: {
    key: 'PUBC',
  },
};
